import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import { getDashboard, getNarrative, getNarratives, transitionNarrative } from '../api'
import {
  DASHBOARD_FETCH_REQUESTED,
  NARRATIVE_FETCH_REQUESTED,
  NARRATIVE_HISTORY_FETCH_REQUESTED,
  TRANSITION_REQUESTED,
} from '../constants'
import {
  dashboardFetchFailed,
  dashboardFetchSucceeded,
  narrativeFetchFailed,
  narrativeHistoryFetchFailed,
  narrativeHistoryFetchSucceeded,
  narrativeFetchSucceeded,
  transitionFailed,
  transitionSucceeded,
} from '../actions/narrative'

export function* requestTransition(action = null) {
  try {
    let { narrative } = action
    ;({ data: narrative } = yield call(transitionNarrative, narrative, action.transition))
    createPermissionShortcuts(narrative)
    renderDates(narrative)
    yield put(transitionSucceeded(narrative))
  } catch (error) {
    yield put(transitionFailed(error))
  }
}

export function* fetchNarrativeHistory(action) {
  try {
    const { cspCountryKey, year } = action
    const { data: narratives } = yield call(getNarratives, cspCountryKey, year)
    // Check whether we can save, for the DraftDocuments editable column
    for (let i = 0; i < narratives.length; i++) {
      createPermissionShortcuts(narratives[i])
      renderDates(narratives[i])
    }
    yield put(narrativeHistoryFetchSucceeded(narratives))
  } catch (error) {
    yield put(narrativeHistoryFetchFailed(error))
  }
}

function createPermissionShortcuts(narrative) {
  // Set narrative.user_can_<permission> and narrative.transition_label_<permission> permission shortcuts
  const available_permissions = Object.keys(narrative.available_transitions_for_current_user)
  for (let t = 0; t < available_permissions.length; t++) {
    const perm_label = narrative.available_transitions_for_current_user[available_permissions[t]]
    let found = false
    // Special cases: ~.user_can_comment, ~.user_can_save and ~.user_can_disclaimer - don't use full transition eg, save_rb_review
    const perms = ['save', 'disclaimer', 'comment']
    for (let p = 0; p < perms.length; p++) {
      if (available_permissions[t].startsWith(`${perms[p]}_`)) {
        narrative[`user_can_${perms[p]}`] = true
        narrative[`transition_label_${perms[p]}`] = perm_label
        found = true
      }
    }
    if (!found) {
      narrative[`user_can_${available_permissions[t]}`] = true
      narrative[`transition_label_${available_permissions[t]}`] = perm_label
    }
  }
}

function splitDate(date) {
  const parts = date.split(/[^0-9]/)
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  return {
    yr: parseInt(parts[0], 10),
    mo: months[parseInt(parts[1], 10) - 1],
    dy: parseInt(parts[2], 10),
    hr: parseInt(parts[3], 10),
    mi: parseInt(parts[4], 10),
  }
}

function renderDate(date) {
  const { dy, mo, yr } = splitDate(date)
  return `${dy} ${mo} ${yr}`
}

function renderDates(narrative) {
  if (narrative.updated) narrative.updated_display = renderDate(narrative.updated)
  if (narrative.created) narrative.created_display = renderDate(narrative.created)
  if (narrative.comment_history && narrative.comment_history.length) {
    for (let v = 0; v < narrative.comment_history.length; v++) {
      narrative.comment_history[v].updated_display = renderDate(narrative.comment_history[v].updated)
    }
  }
}

export function* fetchNarrative(action) {
  try {
    const { id } = action
    const { data: narrative } = yield call(getNarrative, id)
    createPermissionShortcuts(narrative)
    renderDates(narrative)
    yield put(narrativeFetchSucceeded(narrative))
  } catch (error) {
    yield put(narrativeFetchFailed(error))
  }
}

export function* fetchDashboard(action = null) {
  try {
    const response = yield call(getDashboard)
    yield put(dashboardFetchSucceeded(response.data))
  } catch (error) {
    yield put(dashboardFetchFailed(error))
  }
}

export function* watchDashboardFetchRequested() {
  yield takeLatest(DASHBOARD_FETCH_REQUESTED, fetchDashboard)
}
export function* watchNarrativeFetchRequested() {
  yield takeEvery(NARRATIVE_FETCH_REQUESTED, fetchNarrative)
}
export function* watchNarrativeHistoryFetchRequested() {
  yield takeEvery(NARRATIVE_HISTORY_FETCH_REQUESTED, fetchNarrativeHistory)
}
export function* watchTransitionRequested() {
  yield takeEvery(TRANSITION_REQUESTED, requestTransition)
}
